import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { initialSatisfacaoClienteForm, SatisfacaoClienteForm, SatisfacaoClienteSchema } from "../../../schemas/PesquisaCliente_lista/satisfacao_cliente";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect, useMemo } from "react";
import { DefaultFormRadioGroupInput } from "../../../../../../common/components/default_form_radio_group_input";
import FormContainer from "../../../../../../common/components/form_container";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { DefaultFormCheckBox } from "../../../../../../common/components/default_form_checkbox";
import { DefaultFormDatePickerInput } from "../../../../../../common/components/default_form_date_picker_input";
import { SatiscacaoClienteLista } from "../../../../domain/models/satisfacao_cliente_lista";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { ClienteDropDown } from "../../../../../../common/domain/models/cliente_dropdown";
import dayjs from "dayjs";
import PrimaryButton from "../../../../../../components/global/PrimaryButton";

/**
 * PesquisaSatisfacaoClienteModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedSatisfacaoCliente: SatiscacaoClienteLista | null,
  centroCustosDropdown: CentroCustoDropDown[];
  clientesDropdown: ClienteDropDown[];
  onClose: () => void;
  onSubmit: (e: any) => void;
  onOpenChangeHistory: () => void;
};

export const SatisfacaoClienteModal = ({
  open,
  saving,
  loading,
  selectedSatisfacaoCliente,
  centroCustosDropdown,
  clientesDropdown,
  onClose,
  onSubmit,
  onOpenChangeHistory,
}: Props) => {

  const hookForm = useForm<SatisfacaoClienteForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: initialSatisfacaoClienteForm,
    resolver: zodResolver(SatisfacaoClienteSchema),
  });

  const [preencher] = hookForm.watch(['preencher']);

  const statusOptions = useMemo(() => {
    return [
      {
        id: 0,
        label: 'Em Aberto',
        style: {
          backgroundColor: '#f8cb00',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 1,
        label: 'Realizada',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
    ];
  }, [
  ]);

  useEffect(() => {
    if (open) {
      if (selectedSatisfacaoCliente) {
        hookForm.setValue('status', selectedSatisfacaoCliente.status ?? 0);
        hookForm.setValue('centroCusto', selectedSatisfacaoCliente.idCentroCusto ?? 0);
        hookForm.setValue('cliente', selectedSatisfacaoCliente.idCliente);
        hookForm.setValue('nomeCliente', selectedSatisfacaoCliente.descCliente);

        hookForm.setValue('data', selectedSatisfacaoCliente.data !== null && selectedSatisfacaoCliente.data.length > 0
          ? dayjs(selectedSatisfacaoCliente.data).toDate() : null);

        hookForm.setValue('preencher',
          selectedSatisfacaoCliente.idCliente === null && selectedSatisfacaoCliente.descCliente !== null && selectedSatisfacaoCliente.descCliente.length > 0);

      } else {
        hookForm.reset({ ...initialSatisfacaoClienteForm });
      }
    }
  }, [
    hookForm,
    open,
    selectedSatisfacaoCliente,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Satisfação do Cliente'
      leftButtonSlot={
        selectedSatisfacaoCliente &&
        <PrimaryButton
          buttonColor="yellow"
          onClick={() => onOpenChangeHistory()}>
          <span className="text-xs">
            Historico de alterações
          </span>
        </PrimaryButton>
      }
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)} >
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormRadioGroupInput
            name='status'
            label='Status'
            options={statusOptions}
            reactHookForm={hookForm}
          />

          <DefaultFormAutocomplete
            name='centroCusto'
            label='Centro de Custo'
            required={true}
            options={centroCustosDropdown}
            getOptionKey={x => x.id}
            getOptionLabel={x => x.title}
            reactHookForm={hookForm}
          />

          <div className="flex flex-col">
            <div className="min-h-[2.8rem]">
              {
                preencher === false ? (
                  <DefaultFormAutocomplete
                    name='cliente'
                    label='Cliente *'
                    options={clientesDropdown}
                    getOptionKey={x => x.id}
                    getOptionLabel={x => x.title}
                    reactHookForm={hookForm}
                  />
                ) : (
                  <DefaultFormInput
                    name='nomeCliente'
                    label='Cliente *'
                    reactHookForm={hookForm}
                  />
                )
              }
            </div>

            <span className="ms-1">
              <DefaultFormCheckBox
                name='preencher'
                label='Preencher o cliente'
                reactHookForm={hookForm}
                onChangeValue={e => {
                  hookForm.resetField('cliente');
                  hookForm.resetField('nomeCliente');
                }}
              />
            </span>
          </div>

          <DefaultFormDatePickerInput
            name='data'
            label='Data'
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal >
  );
}